import { render, staticRenderFns } from "./AccountProjectIsFinished.vue?vue&type=template&id=0d0aedfa&"
import script from "./AccountProjectIsFinished.vue?vue&type=script&lang=ts&"
export * from "./AccountProjectIsFinished.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports